var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "el-row",
        [
          _c(
            "el-col",
            { attrs: { span: 6 } },
            [
              _c("el-tree", {
                attrs: {
                  data: _vm.deptData,
                  "node-key": "deptId",
                  props: _vm.defaultProps
                },
                on: { "node-click": _vm.handleNodeClick }
              })
            ],
            1
          ),
          _c(
            "el-col",
            { attrs: { span: 18 } },
            [
              _c(
                "el-checkbox-group",
                {
                  attrs: { size: "small" },
                  model: {
                    value: _vm.addIdList,
                    callback: function($$v) {
                      _vm.addIdList = $$v
                    },
                    expression: "addIdList"
                  }
                },
                _vm._l(_vm.userIds, function(item) {
                  return _c(
                    "el-checkbox",
                    {
                      key: item.userName,
                      attrs: { label: item.userId, border: "" }
                    },
                    [_vm._v(_vm._s(item.userName))]
                  )
                }),
                1
              )
            ],
            1
          )
        ],
        1
      ),
      _c(
        "div",
        {
          staticClass: "dialog-footer",
          attrs: { slot: "footer" },
          slot: "footer"
        },
        [
          _c("el-button", { on: { click: _vm.handCancle } }, [
            _vm._v(_vm._s(_vm.$t("button.cancel")))
          ]),
          _c(
            "el-button",
            { attrs: { type: "primary" }, on: { click: _vm.handCreate } },
            [_vm._v(_vm._s(_vm.$t("button.confirm")))]
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }